import { getCasinoBetsError, getCasinoBetsSuccess } from "./casinoBets.slice";
import getErrorMessage from "../../helpers/getErrorMessage.helper";
import http from "../../services/httpAuth";

export const requestCasinoBets = (eventId) => async (dispatch, getState) => {
    const auth = getState().auth;
    let data = {
        limit: 100,
        page: 1,
        search: {
            delete_status: 0,
            match_id: eventId
        }
    }
    if (auth) {
        try {
            // const userId = getState().user.memberCode;
            // const eventParam = eventId ? `&eventId=${eventId}` : "";
            const response = await http.post(`/bet/openBets`, data);
            if (response.data.status) {
                dispatch(getCasinoBetsSuccess(response.data.data));
            }
            return response;
        } catch (e) {
            dispatch(getCasinoBetsError());
            const errorMsg = getErrorMessage(e);
            throw errorMsg;
        }
    }
};

export const requestCasinoBetsWithDate = (from, to, eventId) => async (dispatch, getState) => {
    try {
        const data = {
            limit: 100,
            page: 1,
            bets_type: "open",
            from_date: from,
            to_date: to
        }
        const response = await http.post(`/lotus/bets`, data);
        if (response.data.status) {
            dispatch(getCasinoBetsSuccess(response?.data?.data?.data));
        }
        return response;
    } catch (e) {
        dispatch(getCasinoBetsError());
        const errorMsg = getErrorMessage(e);
        throw errorMsg;
    }
};

export const requestPastBets = (from, to, eventId) => async (dispatch, getState) => {
    try {
        const data = {
            limit: 100,
            page: 1,
            bets_type: "settled",
            from_date: from,
            to_date: to
        }
        const response = await http.post(`/lotus/bets`, data);
        // if (response.data.success) {
        //     dispatch(getOpenBetsSuccess(response.data.result));
        // }
        return response;
    } catch (e) {
        dispatch(getCasinoBetsError());
        const errorMsg = getErrorMessage(e);
        throw errorMsg;
    }
};
